import React from 'react';

import { Brand, CLIENT_IDS } from 'common/constants/enums';
import { ClientContext } from 'providers';

export const isCRCOrg = (brand) => brand?.toLowerCase() === Brand.CODERED;

const getFullyDecodedUrl = () => {
    let url = window?.location?.href || '';

    for (let i = 0; i < 5; i++) {
        let decoded;

        try {
            decoded = decodeURIComponent(url);
        } catch {
            return url;
        }

        if (decoded === url) {
            break;
        }

        url = decoded;
    }

    return url;
};

export const getRequestClientId = () => {
    const [, clientId] = /[?&]client_id=([^&#]*)/.exec(getFullyDecodedUrl()) || [];

    return clientId || null;
};

export const isSelfRegistrationClient = () => getRequestClientId() === CLIENT_IDS.SELF_REGISTRATION_USER;

export const isAuthenticatorAppSetupEnabled = (brand) => {
    return isCRCOrg(brand) && !isSelfRegistrationClient();
};

export const useAuthenticatorAppSetupEnabled = () => {
    const { customizations: { brand } = {} } = React.useContext(ClientContext) || {};

    return isAuthenticatorAppSetupEnabled(brand);
};

export const useSecurityMFAEnabled = () => {
    const { extensions: { isSecurityMFAEnabled } = {} } = React.useContext(ClientContext) || {};

    return isSecurityMFAEnabled ?? false;
};
